module.exports = __webpack_public_path__ + "static/img/logo.34841673.png";